import React, { useEffect } from 'react';
import ExamInsightsArticlePage from '../../features/specialty/editorial/ExamInsightsArticlePage';

export default function LnatInsightsArticleRoute() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return <ExamInsightsArticlePage />;
}
